/* eslint-disable react/jsx-fragments */
import React from 'react';
import FundraiserText, { FundraiserShareTitle } from './FundraiserText';
import EventText, { EventShareTitle } from './EventText';
import SignupText, { SignupShareTitle } from './SignupText';
import PetitionText, { PetitionShareTitle } from './PetitionText';
export default (function (_ref) {
  var resourceType = _ref.resourceType,
      transactionStatus = _ref.transactionStatus;

  switch (resourceType) {
    case 'node.fundraiser':
      return React.createElement(React.Fragment, null, React.createElement(FundraiserText, {
        transactionStatus: transactionStatus
      }));

    case 'node.event':
      return React.createElement(EventText, null);

    case 'node.signup':
      return React.createElement(SignupText, null);

    case 'node.petition':
    default:
      return React.createElement(PetitionText, null);
  }
});
export var ShareTitle = function ShareTitle(_ref2) {
  var resourceType = _ref2.resourceType;

  switch (resourceType) {
    case 'node.fundraiser':
      return React.createElement(FundraiserShareTitle, null);

    case 'node.event':
      return React.createElement(EventShareTitle, null);

    case 'node.signup':
      return React.createElement(SignupShareTitle, null);

    case 'node.petition':
    default:
      return React.createElement(PetitionShareTitle, null);
  }
};